<!--  -->
<template>
  <div>
    <van-swipe-cell :class="{ disabled: disabled }">
      <!--套餐课程 -->
      <div :class="['packCourse', { failureUi: doNot }]">
        <div class="courseTitle">
          <img v-if="doNot" :src="notCk" alt="" />
          <img
            v-else
            :src="checkItem ? checked : noCheck"
            alt=""
            @click.stop="selectItem(courseInfo)"
          />
          <span class="tips">套餐</span>
          <h3>{{ courseInfo.cartPackageItem.name }}</h3>
        </div>
        <div class="containText">包含以下课程</div>
        <div :class="{ heightAct: brandFold }">
          <div
            class="packageBox"
            v-for="(item, index) in courseInfo.cartPackageItem.cartProductItemList"
            :key="index"
          >
            <h3>{{ item.name }}</h3>
            <div class="courseMation">
              <div class="courseType" @click.stop="chooseType(courseInfo)">
                <span>{{ specJson(item.specJson) }}</span
                ><img src="@/assets/img/car/icon01.png" alt="" />
              </div>
              <div class="coursePrice" v-if="!isAccommodation">
                <span>¥</span>{{ item.skuPrice }}
              </div>
            </div>
          </div>
        </div>
        <div class="packagePrice" v-if="isAccommodation"><span>总价：</span>{{courseInfo.cartPackageItem.sellPrice }}</div>

        <div class="expand" v-if="courseInfo.cartPackageItem.cartProductItemList.length > 1">
          <div @click.stop="foldUpCourse">
            {{ brandFold ? '展开' : '收起' }}
            <img :src="brandFold ? zk : sq" alt="" />
          </div>
        </div>
      </div>
      <template #right>
        <div class="delete" @click="deleteGood(courseInfo.cartId)">
          <div>
            <img src="@/assets/img/car/delete.png" class="img" />
            <span>删除</span>
          </div>
        </div>
      </template>
    </van-swipe-cell>
  </div>
</template>

<script>
export default {
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
    // doNot为true 展示失效商品UI
    doNot: {
      type: Boolean,
      default: false,
    },

    checkList: {
      type: Array,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: require('@/assets/img/car/cked.png'),
      noCheck: require('@/assets/img/car/nck.png'),
      zk: require('@/assets/img/car/zk.png'),
      sq: require('@/assets/img/car/sq.png'),
      notCk: require('@/assets/img/car/notck.png'), // 不可操作
      brandFold: true, // 展开收起 默认收起状态
    };
  },

  components: {},
  watch: {},
  computed: {
    checkItem() {
      return this.checkList.filter((item) => item.cartId === this.courseInfo.cartId).length !== 0;
    },
    isAccommodation() {
      const hasDirectAccommodation = this.courseInfo?.cartPackageItem?.cartProductItemList?.some(
        (item) => item && item.isAccommodation === 1,
      );
      return hasDirectAccommodation;
    },
  },

  mounted() {},

  created() {
    this.specJson();
  },

  methods: {
    // 展开收起
    foldUpCourse() {
      this.brandFold = !this.brandFold;
    },
    selectItem(data) {
      if (this.disabled) {
        this.$toast('套餐和单品不可同时选择');
        return;
      }
      if (!this.checkItem) {
        this.$emit('checkOneCourse', data);
      } else {
        this.$emit('cleanCourse', data);
      }
    },
    chooseType(data) {
      this.$emit('chooseType', data);
    },
    deleteGood(cartId) {
      this.$emit('deleteGood', cartId);
    },
    specJson(data) {
      // eslint-disable-next-line no-unused-expressions
      const showType = JSON.parse(data || '[]')?.map((item) => item.value);
      return String(showType);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .van-swipe-cell.disabled {
  opacity: 0.5;
  filter: grayscale(1);
}
.packCourse {
  box-sizing: border-box;
  margin-bottom: 24px;
  margin-left: 40px;
  padding: 40px 32px 24px 24px;
  background: #fff;
  border-radius: 16px;
  .courseTitle {
    display: flex;
    align-items: center;
    margin-bottom: 26px;
    img {
      display: block;
      width: 48px;
      height: 48px;
      margin-right: 16px;
    }
    h3 {
      width: 450px;
      overflow: hidden;
      color: #333;
      font-weight: 500;
      font-size: 32px;
      line-height: 44px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .tips {
      display: inline-block;
      margin-right: 16px;
      padding: 2px 8px;
      color: #6191f2;
      font-weight: 400;
      font-size: 24px;
      line-height: 34px;
      background: #f5f9ff;
      border-radius: 8px;
    }
  }
  .containText {
    margin-left: 65px;
    color: #999;
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
  }
  .heightAct {
    height: 150px;
    overflow: hidden;
  }
  .packageBox {
    margin-top: 24px;
    margin-left: 65px;
    h3 {
      width: 520px;
      margin-bottom: 16px;
      overflow: hidden;
      color: #333;
      font-weight: 400;
      font-size: 28px;
      line-height: 40px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .courseMation {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .courseType {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding-left: 10px;
        background: #f9f9f9;
        border-radius: 7px;
        span {
          min-width: 30px;
          max-width: 270px;
          overflow: hidden;
          color: #999;
          font-weight: 400;
          font-size: 28px;
          line-height: 56px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        img {
          display: block;
          width: 48px;
          height: 48px;
        }
      }
      .coursePrice {
        color: #ff3938;
        font-weight: 500;
        font-size: 40px;
        line-height: 40px;
        span {
          font-size: 30px;
        }
      }
    }
  }
  .expand {
    margin-top: 15px;
    div {
      width: 100px;
      margin: 0 auto;
      color: #999;
      font-weight: 400;
      font-size: 24px;
      line-height: 68px;
      img {
        width: 32px;
        height: 32px;
        margin-left: 4px;
        vertical-align: -7px;
      }
    }
  }
  .packagePrice{
    color: #ff3938;
    display: flex;
    align-items: center;
    justify-content: flex-end;
        font-weight: 500;
        font-size: 40px;
        line-height: 40px;
        span{
          font-size: 30px;
           font-weight: 500;
        }
  }
}
.delete {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 128px;
  height: 100%;
  background: #f84508;
  border-radius: 0 16px 16px 0;
  img {
    width: 48px;
    height: 48px;
  }
  span {
    display: block;
    color: #fff;
    font-weight: 500;
    font-size: 28px;
    line-height: 40px;
  }
}

.failureUi {
  background: #f5f5f5;
  border: 2px solid #eee;
  .courseTitle {
    h3 {
      color: #787878;
    }
    .tips {
      color: #999;
      background: #f9f9f9;
    }
  }
  .packageBox {
    margin-top: 24px;
    margin-left: 65px;
    h3 {
      color: #787878;
    }
    .courseMation {
      .courseType {
        color: #999;
      }
      .coursePrice {
        color: #999;
      }
    }
  }
}
</style>
